import { WifiOff } from "lucide-react";
import { faDateTime } from "@/lib/format";

export const OfflineBadge = ({ board, className = "" }) => {
  if (!board?.offline) return null;
  return (
    <div
      data-testid="offline-badge"
      role="status"
      className={`flex items-center gap-2 rounded-full border border-amber-500/40 bg-amber-500/10 px-4 py-2 text-xs text-amber-200 ${className}`}
      dir="rtl"
    >
      <WifiOff className="h-3.5 w-3.5 shrink-0" />
      <span>
        آفلاین — نمایش آخرین نرخ ذخیره‌شده ({faDateTime(board.updated_at)})
      </span>
    </div>
  );
};
